module.exports = __webpack_public_path__ + "img/login_icon1.0df86a2f.png";